import { mockComponent } from 'bloko/common/setupMockComponents';

export default mockComponent('Item', null, { withChildren: true });
